import { render } from "./addCustomer.vue?vue&type=template&id=ba56325c&scoped=true"
import script from "./addCustomer.vue?vue&type=script&lang=js"
export * from "./addCustomer.vue?vue&type=script&lang=js"

import "./addCustomer.vue?vue&type=style&index=0&id=ba56325c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba56325c"]])

export default __exports__